/**
 * Parse le contenu markdown pour extraire les blocs de code.
 * @param {string} content - Texte avec éventuels blocs ```lang\ncode```
 * @returns {Array<{type: 'text'|'code', value: string, language?: string}>}
 */
export function parseContentWithCode(content) {
  if (!content) return [{ type: 'text', value: '' }];
  const parts = [];
  const regex = /```(\w*)\n([\s\S]*?)```/g;
  let lastIndex = 0;
  let match;
  while ((match = regex.exec(content)) !== null) {
    if (match.index > lastIndex)
      parts.push({ type: 'text', value: content.slice(lastIndex, match.index) });
    const lang = match[1]?.trim() || 'text';
    const code = match[2].trim();
    if (code.length > 5) parts.push({ type: 'code', value: code, language: lang });
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < content.length) parts.push({ type: 'text', value: content.slice(lastIndex) });
  return parts.length ? parts : [{ type: 'text', value: content }];
}
